"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetMiniBagConfigurationData = useGetMiniBagConfigurationData;
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _logger = require("../logger");
const hookName = 'useGetApiConfigurationData';
function useGetMiniBagConfigurationData() {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const swrOptions = {
    ..._checkoutUtils.errorHandlingSwrOptions,
    onSuccess: data => {
      (0, _logger.logInfo)(`${hookName} hook: Part of configuration was loaded via static API.`, data);
    }
  };
  const {
    data,
    isValidating
  } = (0, _staticApiClientReact.useGetTenantApplicationsMiniBagConfiguration)(tenant, {
    swr: swrOptions
  });
  return {
    miniBagConfiguration: data,
    isMiniBagConfigurationLoading: isValidating
  };
}
